<template>
  <div @click="openModal">
    <slot></slot>
    <a-modal
      v-model="visible"
      width="80vw"
      :footer="null"
      :centered="true"
      :closable="false"
      :maskClosable="false"
      :maskStyle="{ background: '#1c1c1c' }"
      wrapClassName="c-turn-modal"
    >
      <div class="c-turn">
        <template v-if="type === 'download'">
          <div class="title">
            {{ $t("light.downloadType") }}
          </div>
          <a-radio-group v-model="KeyboardType" class="radio-group">
            <a-radio class="radio" value="rgb65">AM RGB 65</a-radio>
            <a-radio class="radio" value="r2">{{ $t("R2") }}</a-radio>
            <a-radio class="radio" value="r1">{{ $t("R1") }}</a-radio>
          </a-radio-group>
        </template>
        <div class="title">
          {{ $t(type === "turn" ? "light.turn" : "light.download") }}
        </div>
        <a-radio-group v-model="lightIndex" class="radio-group">
          <a-radio class="radio" :value="4">{{ $t("light.name") }} 1</a-radio>
          <a-radio class="radio" :value="5">{{ $t("light.name") }} 2</a-radio>
          <a-radio class="radio" :value="6">{{ $t("light.name") }} 3</a-radio>
        </a-radio-group>
        <md-checkbox v-model="led" class="checkbox" v-if="hasFrames">
          {{ $t("selectVersion.led") }}
        </md-checkbox>
        <md-checkbox v-model="inSwitch" class="checkbox" v-if="hasKeyframes">
          {{ $t("selectVersion.inSwitch") }}
        </md-checkbox>
        <template v-if="type === 'turn'">
          <div class="title preview-title">
            {{ $t("light.previewTarget") }}
          </div>
          <a-radio-group
            v-model="PreviewKeyboardType"
            class="radio-group preview-targets"
          >
            <a-radio class="radio" value="library">
              {{ $t("light.previewLibrary") }}
            </a-radio>
            <a-radio class="radio" value="rgb65">AM RGB 65</a-radio>
            <a-radio class="radio" value="r2">{{ $t("R2") }}</a-radio>
            <a-radio class="radio" value="r1">{{ $t("R1") }}</a-radio>
          </a-radio-group>
        </template>
        <div class="download-tip" v-if="type === 'download'">
          {{ $t("light.downloadTip") }}
        </div>
        <div class="buttons">
          <md-button class="button" @click="visible = false">
            {{ $t("cancel") }}
          </md-button>
          <md-button
            class="button"
            :disabled="!canApply"
            @click="onTurn(false)"
          >
            {{ $t("yes") }}
          </md-button>

          <md-button
            v-if="type === 'download'"
            class="button"
            :style="!isCN ? { width: '280px' } : { width: '200px' }"
            @click="onTurn(true)"
          >
            {{ $t("light.downloadAllJsonfile") }}
          </md-button>
        </div>
        <div class="tip" v-if="type === 'turn'">
          {{ $t("light.turnTip") }}
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { deepCopy, download } from "@/utils";

export default {
  name: "CProfileTurn",
  props: {
    content: Object,
    type: String,
  },
  data() {
    return {
      visible: false,
      lightIndex: 4,
      led: true,
      inSwitch: true,
      KeyboardType: "rgb65",
      PreviewKeyboardType: "library",
    };
  },
  computed: {
    ...mapState(["profile65GameBoy", "profileNew", "profile"]),
    ...mapState("app", {
      isCN: "isCN",
    }),
    hasKeyframes() {
      return Boolean(
        this.content &&
          this.content.keyframes &&
          Array.isArray(this.content.keyframes.frame_data) &&
          this.content.keyframes.frame_data.length
      );
    },
    hasFrames() {
      return Boolean(
        this.content &&
          this.content.frames &&
          Array.isArray(this.content.frames.frame_data) &&
          this.content.frames.frame_data.length
      );
    },
    canApplyLed() {
      return this.led && this.hasFrames;
    },
    canApplyInSwitch() {
      return this.inSwitch && this.hasKeyframes;
    },
    canApply() {
      return this.canApplyLed || this.canApplyInSwitch;
    },
  },
  methods: {
    openModal() {
      if (this.visible) return;
      this.visible = true;
      this.led = this.hasFrames;
      this.inSwitch = this.hasKeyframes;
      this.PreviewKeyboardType = "library";
    },
    async onTurn(isFullJson) {
      if (!isFullJson && !this.canApply) return;

      // AM RGB 65
      let page_data = deepCopy(this.profile65GameBoy.data.page_data);
      if (this.canApplyLed)
        page_data[this.lightIndex + 1].frames = deepCopy(this.content.frames);
      if (this.canApplyInSwitch)
        page_data[this.lightIndex + 1].keyframes = deepCopy(
          this.content.keyframes
        );
      if (this.type === "download" && this.KeyboardType === "rgb65") {
        page_data[5].frames.valid = isFullJson ? 1 : 2;
        page_data[5].keyframes.valid = isFullJson ? 1 : 2;
        page_data[6].frames.valid = isFullJson ? 1 : 2;
        page_data[6].keyframes.valid = isFullJson ? 1 : 2;
        page_data[7].frames.valid = isFullJson ? 1 : 2;
        page_data[7].keyframes.valid = isFullJson ? 1 : 2;
        page_data[this.lightIndex + 1].frames.valid = this.canApplyLed
          ? 1
          : isFullJson
          ? 1
          : 2;
        page_data[this.lightIndex + 1].keyframes.valid = this.canApplyInSwitch
          ? 1
          : isFullJson
          ? 1
          : 2;
        console.log(
          this.profile65GameBoy.data.key_layer,
          "this.profile65GameBoy.data.key_layer"
        );
        const file = new Blob([
          JSON.stringify({
            ...this.profile65GameBoy.data,
            page_data,
            key_layer: {
              ...this.profile65GameBoy.data.key_layer,
              valid: isFullJson ? 1 : 2,
            },
          }),
        ]);
        const fileName = "AM-RGB-65.json";
        this.$confirm({
          title: this.$t("keyboard.downloadTip", ["AM RGB 65"]),
          onOk: () => {
            download(file, fileName);
            this.$message.info(this.$t("keyboard.downloadSuccessfully"));
          },
          width: "8.4rem",
          okText: this.$t("yes"),
          cancelText: this.$t("cancel"),
          centered: true,
        });
      } else if (this.type === "turn") {
        await this.$store.dispatch("profile65GameBoy/setData", {
          ...this.profile65GameBoy.data,
          page_data,
        });
        await this.$store.dispatch(
          "profile65GameBoy/setLightIndex",
          this.lightIndex + 1
        );
      }

      console.log("AM RGB 65");

      // R2
      page_data = deepCopy(this.profileNew.data.page_data);
      if (this.canApplyLed)
        page_data[this.lightIndex + 1].frames = deepCopy(this.content.frames);
      if (this.canApplyInSwitch)
        page_data[this.lightIndex + 1].keyframes = deepCopy(
          this.content.keyframes
        );
      if (this.type === "download" && this.KeyboardType === "r2") {
        page_data[5].frames.valid = isFullJson ? 1 : 2;
        page_data[5].keyframes.valid = isFullJson ? 1 : 2;
        page_data[6].frames.valid = isFullJson ? 1 : 2;
        page_data[6].keyframes.valid = isFullJson ? 1 : 2;
        page_data[7].frames.valid = isFullJson ? 1 : 2;
        page_data[7].keyframes.valid = isFullJson ? 1 : 2;
        page_data[this.lightIndex + 1].frames.valid = this.canApplyLed
          ? 1
          : isFullJson
          ? 1
          : 2;
        page_data[this.lightIndex + 1].keyframes.valid = this.canApplyInSwitch
          ? 1
          : isFullJson
          ? 1
          : 2;
        const file = new Blob([
          JSON.stringify({
            ...this.profileNew.data,
            page_data,
            key_layer: {
              ...this.profileNew.data.key_layer,
              valid: isFullJson ? 1 : 2,
            },
          }),
        ]);
        const fileName = "AM-CB.json";
        this.$confirm({
          title: this.$t("keyboard.downloadTip", [this.$t("R2")]),
          onOk: () => {
            download(file, fileName);
            this.$message.info(this.$t("keyboard.downloadSuccessfully"));
          },
          width: "8.4rem",
          okText: this.$t("yes"),
          cancelText: this.$t("cancel"),
          centered: true,
        });
      } else if (this.type === "turn") {
        await this.$store.dispatch("profileNew/setData", {
          ...this.profileNew.data,
          page_data,
        });
      }
      console.log("R2");

      // R1
      let lightEffects = deepCopy(this.profile.data.lightEffects);
      if (this.canApplyLed)
        lightEffects[this.lightIndex].frames = this.getFrames(
          deepCopy(this.content.frames.frame_data)
        );
      if (this.canApplyInSwitch)
        lightEffects[this.lightIndex + 7].frames = this.getKeyFrames(
          deepCopy(this.content.keyframes.frame_data)
        );
      if (this.canApplyLed) lightEffects[this.lightIndex].speed.value = 10;
      if (this.type === "download" && this.KeyboardType === "r1") {
        const file = new Blob([
          JSON.stringify({
            ...this.profile.data,
            lightEffects,
          }),
        ]);
        const fileName = "AM-CBR1&XMAS.json";
        this.$confirm({
          title: this.$t("keyboard.downloadTip", [this.$t("R1")]),
          onOk: () => {
            download(file, fileName);
            this.$message.info(this.$t("keyboard.downloadSuccessfully"));
          },
          width: "8.4rem",
          okText: this.$t("yes"),
          cancelText: this.$t("cancel"),
          centered: true,
        });
      } else if (this.type === "turn") {
        await this.$store.dispatch("profile/setData", {
          ...this.profile.data,
          lightEffects,
        });
        await this.$store.dispatch("profile/setLightIndex", this.lightIndex);
        this.$message.info(this.$t("keyboard.turnSuccessfully"));
      }
      console.log("R1");

      this.visible = false;
      if (this.type === "turn") await this.navigateToPreview();
    },
    async navigateToPreview() {
      if (!this.canApply || this.PreviewKeyboardType === "library") return;
      const mode =
        this.canApplyLed && this.canApplyInSwitch
          ? "overview"
          : this.canApplyLed
          ? "led"
          : "inSwitch";
      const routes = {
        rgb65: {
          overview: this.$paths.index65GameBoy,
          led: this.$paths.light65GameBoy,
          inSwitch: this.$paths.inSwitchLED65GameBoy,
        },
        r1: {
          overview: this.$paths.index,
          led: this.$paths.light,
          inSwitch: this.$paths.inSwitchLED,
        },
        r2: {
          overview: this.$paths.indexR6,
          led: this.$paths.lightR6,
          inSwitch: this.$paths.inSwitchLEDR6,
        },
      };
      if (this.PreviewKeyboardType === "r1") {
        await this.$store.dispatch("profile/setVersion", "r1");
      }
      return this.$router.push({
        path: routes[this.PreviewKeyboardType][mode],
        query: { light: String(this.lightIndex - 3) },
      });
    },
    getFrames(frames) {
      let frameData = [];
      frames.map((frame, index) => {
        let frameRGB = [];
        for (let i = 0; i < 40; i++) {
          for (let j = 0; j < 5; j++) {
            frameRGB.push(frame.frame_RGB[j * 40 + i]);
          }
        }
        frameData.push({
          frameRGB,
          frameIndex: index + 1,
        });
      });
      return frameData;
    },
    getKeyFrames(frames) {
      frames.map((frame) => {
        let frameRGB = new Array(84);
        frameRGB[0] = frame.frame_RGB[0];
        frameRGB[1] = frame.frame_RGB[0];
        frameRGB[2] = frame.frame_RGB[1];
        frameRGB[3] = frame.frame_RGB[2];
        frameRGB[4] = frame.frame_RGB[3];
        frameRGB[5] = frame.frame_RGB[4];
        frameRGB[6] = frame.frame_RGB[5];
        frameRGB[7] = frame.frame_RGB[6];
        frameRGB[8] = frame.frame_RGB[7];
        frameRGB[9] = frame.frame_RGB[8];
        frameRGB[10] = frame.frame_RGB[9];
        frameRGB[11] = frame.frame_RGB[10];
        frameRGB[12] = frame.frame_RGB[11];
        frameRGB[13] = frame.frame_RGB[12];
        frameRGB[14] = frame.frame_RGB[13];
        frameRGB[70] = frame.frame_RGB[14];

        frameRGB[15] = frame.frame_RGB[15];
        frameRGB[16] = frame.frame_RGB[16];
        frameRGB[17] = frame.frame_RGB[17];
        frameRGB[18] = frame.frame_RGB[18];
        frameRGB[19] = frame.frame_RGB[19];
        frameRGB[20] = frame.frame_RGB[20];
        frameRGB[21] = frame.frame_RGB[21];
        frameRGB[22] = frame.frame_RGB[22];
        frameRGB[23] = frame.frame_RGB[23];
        frameRGB[24] = frame.frame_RGB[24];
        frameRGB[25] = frame.frame_RGB[25];
        frameRGB[26] = frame.frame_RGB[26];
        frameRGB[27] = frame.frame_RGB[27];
        frameRGB[28] = frame.frame_RGB[28];
        frameRGB[69] = frame.frame_RGB[29];

        frameRGB[29] = frame.frame_RGB[30];
        frameRGB[30] = frame.frame_RGB[31];
        frameRGB[31] = frame.frame_RGB[32];
        frameRGB[32] = frame.frame_RGB[33];
        frameRGB[33] = frame.frame_RGB[34];
        frameRGB[34] = frame.frame_RGB[35];
        frameRGB[35] = frame.frame_RGB[36];
        frameRGB[36] = frame.frame_RGB[37];
        frameRGB[37] = frame.frame_RGB[38];
        frameRGB[38] = frame.frame_RGB[39];
        frameRGB[39] = frame.frame_RGB[40];
        frameRGB[40] = frame.frame_RGB[41];
        frameRGB[41] = frame.frame_RGB[42];
        frameRGB[42] = frame.frame_RGB[43];
        frameRGB[68] = frame.frame_RGB[44];

        frameRGB[43] = frame.frame_RGB[45];
        frameRGB[44] = frame.frame_RGB[46];
        frameRGB[45] = frame.frame_RGB[47];
        frameRGB[46] = frame.frame_RGB[48];
        frameRGB[47] = frame.frame_RGB[49];
        frameRGB[48] = frame.frame_RGB[50];
        frameRGB[49] = frame.frame_RGB[51];
        frameRGB[50] = frame.frame_RGB[52];
        frameRGB[51] = frame.frame_RGB[53];
        frameRGB[52] = frame.frame_RGB[54];
        frameRGB[53] = frame.frame_RGB[55];
        frameRGB[54] = frame.frame_RGB[56];
        frameRGB[55] = frame.frame_RGB[58];
        frameRGB[56] = frame.frame_RGB[59];

        frameRGB[57] = frame.frame_RGB[60];
        frameRGB[58] = frame.frame_RGB[62];
        frameRGB[59] = frame.frame_RGB[63];
        frameRGB[60] = frame.frame_RGB[64];
        frameRGB[61] = frame.frame_RGB[65];
        frameRGB[62] = frame.frame_RGB[66];
        frameRGB[63] = frame.frame_RGB[67];
        frameRGB[64] = frame.frame_RGB[68];
        frameRGB[65] = frame.frame_RGB[69];
        frameRGB[66] = frame.frame_RGB[70];
        frameRGB[67] = frame.frame_RGB[71];
        frameRGB[82] = frame.frame_RGB[72];
        frameRGB[83] = frame.frame_RGB[73];

        frameRGB[71] = frame.frame_RGB[75];
        frameRGB[72] = frame.frame_RGB[76];
        frameRGB[73] = frame.frame_RGB[77];
        frameRGB[74] = frame.frame_RGB[79];
        frameRGB[75] = frame.frame_RGB[80];
        frameRGB[76] = frame.frame_RGB[81];
        frameRGB[77] = frame.frame_RGB[85];
        frameRGB[78] = frame.frame_RGB[86];
        frameRGB[79] = frame.frame_RGB[87];
        frameRGB[80] = frame.frame_RGB[88];
        frameRGB[81] = frame.frame_RGB[89];

        frame.frame_RGB = frameRGB;
      });

      let frameData = [];

      frames.map((frame) => {
        frame.frame_RGB.map((RGB) => {
          if (
            !frameData[frameData.length - 1] ||
            frameData[frameData.length - 1].frameRGB.length === 200
          ) {
            frameData.push({
              frameIndex: frameData.length + 1,
              frameRGB: [],
            });
          }
          frameData[frameData.length - 1].frameRGB.push(RGB);
        });
      });

      return frameData;
    },
  },
};
</script>
<style lang="scss" scoped>
.c-turn {
  @include flex-center;
  width: 900px;
  max-width: 100%;
  flex-direction: column;
  margin: 0 auto;
  position: relative;

  .title,
  .tip {
    font-size: 24px;
    color: $active-color;
    margin-bottom: 10px;
    text-align: center;
  }

  .tip {
    font-size: 16px;
    margin-top: 30px;
    color: #ffffff;
  }

  .preview-title {
    margin-top: 24px;
  }

  .download-tip {
    font-size: 18px;
    color: $active-color;
    text-align: center;
    margin-top: 30px;
    color: $active-color;
    cursor: text;
    user-select: text;
  }

  .radio-group {
    max-width: 100%;
    margin-bottom: 30px;

    .radio {
      @include flex-center;
      min-height: 50px;
      line-height: 1.5;
      white-space: normal;
      color: #ffffff;
      justify-content: flex-start;

      &:hover {
        color: $active-color;
      }
    }
  }

  .checkbox {
    color: #ffffff;
    font-size: 22px;

    &:hover {
      color: $active-color;
    }
  }

  .preview-targets {
    display: grid;
    grid-auto-flow: column;
    grid-template-rows: repeat(2, auto);
    grid-template-columns: repeat(2, minmax(0, max-content));
    column-gap: 64px;
    width: fit-content;

    .radio {
      min-width: 0;
      margin-right: 0;
      text-align: left;

      ::v-deep .ant-radio + span {
        min-width: 0;
        overflow-wrap: anywhere;
      }
    }
  }

  .buttons {
    @include flex-center;
    width: 100%;
    margin-top: 40px;

    .button {
      width: 150px;
      height: 53px;
      background-color: $active-color;
      border-radius: 5px;
      font-size: 20px;
      text-transform: none;

      & + .button {
        margin-left: 100px;
      }
    }
  }
}
</style>
<style lang="scss">
.c-turn {
  .radio-group {
    .radio {
      .ant-radio-inner {
        border: 2px solid $active-color !important;

        &::after {
          background-color: $active-color !important;
        }
      }
    }
  }
}
</style>
